module.exports = __webpack_public_path__ + "img/y_2017_hover.72432a48.png";